import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=70e47fe4&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=ts"
export * from "./HomeNews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e47fe4",
  null
  
)

export default component.exports